import React, { useMemo } from 'react'
import { getWindow } from '@ztechapps/common.utils'

export const useWebRouter = () => {
  const push = React.useCallback((route) => {
    getWindow().location.href = route
  }, [])

  const goBack = React.useCallback((num = -1) => {
    getWindow().history.go(num)
  }, [])

  return useMemo(() => ({ push, goBack }), [push, goBack])
}
